import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
export var afterSaleRoute = [{
  path: "after-sale",
  name: "after-sale",
  component: function component() {
    return import( /* webpackChunkName: "car-detail" */"./after-sale.vue");
  }
}];